import Icon, { ValidIcon } from '@/components/Icon'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import * as styles from './style'

export interface Props {
  icon: ValidIcon
  title?: string
  subtitle?: string
}

const StatItem = ({ icon, title, subtitle }: Props): JSX.Element => (
  <Layout spacing="md">
    <Stack className={styles.statContainer} x>
      <Icon className={styles.icon} name={icon} size={28} />
      <Stack y>
        {title && (
          <Text className={styles.title} size="md" weight="md">
            {title}
          </Text>
        )}
        {subtitle && (
          <Text className={styles.subTitle} size="xxs" weight="sm">
            {subtitle}
          </Text>
        )}
      </Stack>
    </Stack>
  </Layout>
)
export default StatItem
